import { parseCardsForFeature } from '@/assets/scripts/parsers/cards'

/** returns Cards list
@return { Array }
*/
export const getCardsList = state => {
	return parseCardsForFeature(state.cardsList).map(card => {
		return {
			...card,
			productName: card.product,
			cardDescription: card.friendlyName.length ? card.friendlyName : null,
			availableBalance: card.accountingBalance,
			cardBalance: card.balance,
			cardCurrency: card.currency
		}
	})
}

/** returns Last Transfers List
@return { Array }
*/
export const getLastTransfersList = state => state.lastTransfersList

/** returns Favorites List
@return { Array }
*/
export const getFavoritesList = state => state.favoritesList

/** returns Favorites hasMore value
@return { Boolean }
*/
export const getFavoritesHasMore = state => state.favoritesHasMore